import _createClass from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
/**
 * Explicit error types.
 *
 * See the following link for more information about why the code includes
 * calls to setPrototypeOf:
 *
 * https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */
// tslint:enable
/**
 * Equivalent of Python's AttributeError.
 */
export var AttributeError = /*#__PURE__*/function (_Error) {
  _inherits(AttributeError, _Error);
  var _super = _createSuper(AttributeError);
  function AttributeError(message) {
    var _this;
    _classCallCheck(this, AttributeError);
    _this = _super.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this), AttributeError.prototype);
    return _this;
  }
  return _createClass(AttributeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Equivalent of Python's RuntimeError.
 */
export var RuntimeError = /*#__PURE__*/function (_Error2) {
  _inherits(RuntimeError, _Error2);
  var _super2 = _createSuper(RuntimeError);
  function RuntimeError(message) {
    var _this2;
    _classCallCheck(this, RuntimeError);
    _this2 = _super2.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this2), RuntimeError.prototype);
    return _this2;
  }
  return _createClass(RuntimeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Equivalent of Python's ValueError.
 */
export var ValueError = /*#__PURE__*/function (_Error3) {
  _inherits(ValueError, _Error3);
  var _super3 = _createSuper(ValueError);
  function ValueError(message) {
    var _this3;
    _classCallCheck(this, ValueError);
    _this3 = _super3.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this3), ValueError.prototype);
    return _this3;
  }
  return _createClass(ValueError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Equivalent of Python's NotImplementedError.
 */
export var NotImplementedError = /*#__PURE__*/function (_Error4) {
  _inherits(NotImplementedError, _Error4);
  var _super4 = _createSuper(NotImplementedError);
  function NotImplementedError(message) {
    var _this4;
    _classCallCheck(this, NotImplementedError);
    _this4 = _super4.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this4), NotImplementedError.prototype);
    return _this4;
  }
  return _createClass(NotImplementedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Equivalent of Python's AssertionError.
 */
export var AssertionError = /*#__PURE__*/function (_Error5) {
  _inherits(AssertionError, _Error5);
  var _super5 = _createSuper(AssertionError);
  function AssertionError(message) {
    var _this5;
    _classCallCheck(this, AssertionError);
    _this5 = _super5.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this5), AssertionError.prototype);
    return _this5;
  }
  return _createClass(AssertionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Equivalent of Python's IndexError.
 */
export var IndexError = /*#__PURE__*/function (_Error6) {
  _inherits(IndexError, _Error6);
  var _super6 = _createSuper(IndexError);
  function IndexError(message) {
    var _this6;
    _classCallCheck(this, IndexError);
    _this6 = _super6.call(this, message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(_assertThisInitialized(_this6), IndexError.prototype);
    return _this6;
  }
  return _createClass(IndexError);
}( /*#__PURE__*/_wrapNativeSuper(Error));